import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.min.js';
import { ChakraProvider, extendTheme, ColorModeScript } from '@chakra-ui/react';
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Main from "./main/components/Main";
import Navbar from "./main/components/lead/Navbar";
import Templates from "./main/components/other/latestProjects/Templates";
import LiveProjects from "./main/components/other/latestProjects/LiveProjects";

// Force Chakra UI to Dark Mode globally
const theme = extendTheme({
    config: {
        initialColorMode: 'dark',
        useSystemColorMode: false,
    },
    styles: {
        global: {
            body: {
                bg: '#030712',
                color: '#f8fafc',
            },
        },
    },
});

export default function App() {
    return (
        <ChakraProvider theme={theme}>
            <ColorModeScript initialColorMode={theme.config.initialColorMode} />
            <div className="App">
                <BrowserRouter>
                    <Routes>
                        <Route path="/" element={<Navbar />}>
                            <Route index element={<Main />} />
                            <Route path="templates" element={<Templates />} />
                            <Route path="live-projects" element={<LiveProjects />} />
                        </Route>
                    </Routes>
                </BrowserRouter>
            </div>
        </ChakraProvider>
    );
}